export default __webpack_public_path__ + "assets/text_widget.ebec32bd1973c57d7c1606663e4c4cc4.svg";